import { app } from "../../../../../Frame/App";

export class CustomAmpel {

    private static promises: { [id: string]: any } = {};

    /**
     * Custom Ampel using a fixed value or ajax to retrieve its value. 
     * 
     * Usage: <div data-custom-ampel data-custom-ampel-url="~/my/url" />
     * Or <div data-custom-ampel data-ampel-value="1" />
     * @param element
     */
    public create = (element: HTMLElement) => {
        let caElements = element.querySelectorAll("[data-custom-ampel]");
        caElements.forEach(e => {
            let caElement = e as HTMLElement;
            let url = caElement.getAttribute("data-custom-ampel-url");
            let fixedValue = caElement.getAttribute("data-ampel-value");

            if (url) {

                let promise = $.ajax({
                    url: app.resolveUrl(url),
                    method: "GET",
                    success: (response) => {
                        let ampelClass = this.getAmpelColor(response);
                        caElement.classList.add(ampelClass);
                        caElement.attributes.removeNamedItem("data-custom-ampel-url");
                        caElement.setAttribute("data-ampel-value", response.toString());
                    },
                    error: (err) => {
                        console.log(err);
                    }
                });

                if (caElement.id) {
                    CustomAmpel.promises[caElement.id] = promise;
                }
            } else if (fixedValue) {
                let value = Number(fixedValue);
                if (!isNaN(value)) {
                    let ampelClass = this.getAmpelColor(value);
                    caElement.classList.add(ampelClass);
                }
            }
        });
    }

    /**
     * Usage: <div ... data-aggregate-ampel="<id of source ampel>,<id of source ampel>,..." data-aggregate-ampel-url="~/api/controller/..."></div>
     * 
     * Takes the values found in "data-ampel-value" of the given source elements, puts the values into an array and calls the given api-url with this array 
     * to calculate the average using a customer specific algorithm. The returned value is then applied to the element.
     * @param element
     * @param masterElement Pass the complete Element that was created by the widget, to find all referenced custom traffic lights that may be referenced here.
     * Since this can be a deferred element, some referenced traffic lights can be defined elsewhere.
     */
    public createAggregateAmpeln = (element: HTMLElement, masterElement: HTMLElement = null) => {

        let aaElements = element.querySelectorAll("[data-aggregate-ampel]");
        aaElements.forEach(e => {
            let aaElement = e as HTMLElement;

            let sourceAmpelIds = aaElement.getAttribute("data-aggregate-ampel");
            let url = aaElement.getAttribute("data-aggregate-ampel-url");

            if (url && url.length > 0 && sourceAmpelIds && sourceAmpelIds.length > 0) {
                let parts = sourceAmpelIds.split(",");

                let relevantPromises = [];
                let sourceAmpelElements: HTMLElement[] = [];

                for (let part of parts) {
                    let sourceAmpelElement = element.querySelector("#" + part) as HTMLElement;
                    if (!sourceAmpelElement && masterElement) {
                        // try to find it in the masterElement if it has a value
                        sourceAmpelElement = masterElement.querySelector("#" + part) as HTMLElement;
                    }

                    if (sourceAmpelElement) {
                        sourceAmpelElements.push(sourceAmpelElement);

                        if (CustomAmpel.promises[part]) {
                            relevantPromises.push(CustomAmpel.promises[part]);
                        }
                    }
                }

                // See if we need a function like Promise.allSettled here 
                // - we need this if the aggregate should still be computed, of one of the custom ampel functions fails.

                Promise.all(relevantPromises)
                    .then(() => {
                        let values: number[] = [];

                        for (let sourceAmpelElement of sourceAmpelElements) {
                            let ampelValue = sourceAmpelElement.getAttribute("data-ampel-value");
                            let ampelValueNumber = Number(ampelValue);

                            if (!isNaN(ampelValueNumber)) {
                                values.push(ampelValueNumber);
                            }
                        }

                        if (values.length > 0) {
                            $.ajax({
                                url: app.resolveUrl(url),
                                method: "POST",
                                contentType: "application/json",
                                data: JSON.stringify(values),
                                success: (response) => {
                                    let ampelClass = this.getAmpelColor(response);
                                    aaElement.classList.add(ampelClass);
                                    aaElement.setAttribute("ampel-value", response.toString());
                                },
                                error: (err) => {
                                    console.log(err);
                                },
                            });

                        }
                    });
            }
            //aaElement.removeAttribute("data-aggregate-ampel-url");
            //aaElement.removeAttribute("data-aggregate-ampel");
            aaElement.classList.add("ampel-grey");
        });

    }

    private getAmpelColor(value: number): string {
        switch (value) {
            case 0:
                return "ampel-red";
            case 1:
                return "ampel-yellow";
            case 2:
                return "ampel-blue";
            case 3:
                return "ampel-green";
        }
    }

    private ajax_call = (resolve, reject, method, url, data) => {
        return new Promise(function (resolve, reject) {
            let xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function () {
                if (this.readyState == 4) {
                    if (this.status == 200)
                        resolve(this.responseText);
                    else
                        reject('Call Failed');
                }
            };
            xhttp.open(method, url);
            if (data) {
                xhttp.setRequestHeader("Content-Type", "application/json");
                xhttp.send(JSON.stringify(data));
            } else {
                xhttp.send();
            }
        });
    }

}